import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Helper = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={FeedbackSignals.Helper}>
    {children}
  </InlineFeedbackBase>
);

export default Helper;
